import {USER_INFO_COOKIE} from '../constants'

type UserInfo = {
  id: number
}

const checkUserInfo = (): UserInfo | undefined => {
  let userInfo: UserInfo

  // Return if called on server
  if (typeof document === 'undefined') {
    return userInfo
  }

  const userInfoCookie = document.cookie.split('; ').find(row => row.startsWith(USER_INFO_COOKIE))

  if (userInfoCookie) {
    userInfo = JSON.parse(decodeURIComponent(userInfoCookie.split('=')[1]))
  }

  return userInfo
}

export default checkUserInfo
